import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bcef018a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bcef018a&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=bcef018a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcef018a",
  null
  
)

export default component.exports